import { env } from '@/env.mjs'
import type { StrapiImageMedia } from '@/types/api'
import type { StaticImport } from '@/types/next'

// TODO: make this generic - return same type as argument has
export const formatImageUrl = (imageUrl: string | StaticImport | undefined | null) => {
	const baseUrl = env.NEXT_PUBLIC_DEV_STRAPI_URL

	if (!imageUrl && !baseUrl) {
		return undefined
	}

	if (typeof imageUrl === 'string') {
		if (!imageUrl.startsWith('http')) {
			if (imageUrl.startsWith('/uploads')) {
				return `${baseUrl?.replace(/\/$/, '')}${imageUrl}`
			}
		}
	}

	return imageUrl
}

export const getImageUrl = (
	image: { media?: StrapiImageMedia | null; fallbackSrc?: string | null } | null | undefined,
	format: keyof StrapiImageMedia['formats'] | 'original' = 'original',
) => {
	if (image == null) {
		return undefined
	}

	if (format !== 'original' && image.media?.formats?.[format]?.url != null) {
		return image.media.formats[format].url
	}

	if (image.media?.url) {
		return image.media.url
	}

	if (image.fallbackSrc) {
		return image.fallbackSrc
	}

	return undefined
}
